export default __webpack_public_path__ + "static/media/icon.4824c00b.svg";